<script>
  import { onMount } from "svelte";
  import { geoPath, geoAlbersUsa } from "d3-geo";
  import { tweened } from "svelte/motion";
  import { scaleLinear } from "d3-scale";
  import { extent } from "d3-array";
  import { cubicOut } from "svelte/easing";

  export let step;

  let colorScale1 = () => {},
  colorScale3 = () => {}

  let data = [];

  const tweenOptions = {
    delay: 0,
    duration: 1000,
    easing: cubicOut,
  };

  const projectionAlbersUsa = geoAlbersUsa().scale(2800).translate([1100,350])
  
  const projection = tweened(projectionAlbersUsa)

  $: path = geoPath().projection($projection);

  onMount(async () => {
    const response = await fetch(
      "https://vera-insights-data-viz.s3.amazonaws.com/california/california.json"
    );

    const json = await response.json();

    const var1Extent = extent(json.features, d => d.properties.var1);
    const var3Extent = extent(json.features, d => d.properties.var3);

    colorScale1 = scaleLinear()
      .domain(var1Extent)
      .range(["#ff0000", "#fff000"]);

      colorScale3 = scaleLinear()
      .domain(var3Extent)
      .range(["green", "aqua"]);

      data = json.features;
  });
  let cScale, prop
  
  $: {
    if (step == 0) {
      tweened(cScale = colorScale1)
      tweened(prop = 'var1')
    }
    if (step == 1) {
      tweened(cScale = colorScale1)
      tweened(prop = 'var2')
    }
    if (step == 2) {
      tweened(cScale = colorScale1)
      tweened(prop = 'var3')
    }
    if (step == 3) {
      tweened(cScale = colorScale3)
      tweened(prop = 'var4')
    }
    if (step == 4) {
      tweened(cScale = colorScale3)
      tweened(prop = 'var5')
    }
    if (step == 5) {
      tweened(cScale = colorScale3)
      tweened(prop = 'var6')
    }
  }


</script>

<svg width="600" height="600" id="map">
  {#each data as feature}
  <path 
  d={path(feature)} 
  class={feature.properties.NAME} 
  fill={cScale(feature.properties[prop])}
  />
  {/each}
</svg>

<style>
  svg {
    width: 600px;
    height: 600px;
  }
  .counties {
    stroke-width: 1px;
    stroke: #999;
    fill: #fff;
  }
  /* begin scrolly styles */

  :global(body) {
    overflow-x: hidden;
  }

  .hero {
    height: 60vh;
    display: flex;
    place-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .hero h2 {
    margin-top: 0;
    font-weight: 200;
  }

  .spacer {
    height: 40vh;
  }

  .sticky {
    position: sticky;
    top: 10%;
    flex: 1 1 60%;
    width: 60%;
  }

  .section-container {
    margin-top: 1em;
    text-align: center;
    transition: background 100ms;
    display: flex;
  }

  .step {
    height: 80vh;
    display: flex;
    place-items: center;
    justify-content: center;
  }

  .step-content {
    font-size: 1rem;
    background: whitesmoke;
    color: #ccc;
    border-radius: 5px;
    padding: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: background 500ms ease;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);
    text-align: left;
    width: 75%;
    margin: auto;
    max-width: 500px;
  }

  .step.active .step-content {
    background: white;
    color: black;
  }

  .steps-container,
  .sticky {
    height: 100%;
  }

  .steps-container {
    flex: 1 1 40%;
    z-index: 10;
  }

  /* Comment out the following line to always make it 'text-on-top' */
  @media screen and (max-width: 768px) {
    .section-container {
      flex-direction: column-reverse;
    }
    .sticky {
      width: 95%;
      margin: auto;
    }
    svg {
      width: 400px;
    }
  }
</style>
